"use strict";
module.exports = function(config, get, post){
	return {
		get: get_custom_report,
		list: list_custom_reports,
		raw: build_raw_report,
		update: update_custom_report_schema,
		create: create_custom_report_schema,
		schedule: schedule_custom_report,
		render: {
			csv: render_csv,
			pdf: render_pdf,
			xlsx: render_xlsx,
			pbix: render_pbix
		}
	};

	function get_custom_report(id) {
		return get("/v2/org/customreports/get", {
			id,
		});
	}

	function list_custom_reports(){
		return get("/v2/org/customreports/list");
	}

	function build_raw_report(schema, params) {
		/**
		 * Params can contain:
		 * filename (string)
		 * createdBy (ObjectId)
		 * orgGroup (ObjectId)
		 * patient (ObjectId)
		 * start (Date)
		 * end (Date)
		 */
		return post("/v2/org/customreports/raw", {
			schema,
			params,
		});
	}

	function update_custom_report_schema(id, schema) {
		return post("/v2/org/customreports/update", {
			id,
			schema,
		});
	}

	function create_custom_report_schema(schema) {
		return post("/v2/org/customreports/create", {
			schema,
		});
	}

	function schedule_custom_report(id, schedule) {
		return post("/v2/org/customreports/schedule", {
			id,
			schedule
		});
	}

	function render_csv(raw, params) {
		return post("/v2/org/customreports/render/csv", {
			raw,
			params,
		});
	}

	function render_pdf(raw, params) {
		return post("/v2/org/customreports/render/pdf", {
			raw,
			params,
		});
	}

	function render_xlsx(raw, params) {
		return post("/v2/org/customreports/render/xlsx", {
			raw,
			params,
		});
	}

	function render_pbix(raw, params){
		return post("/v2/org/customreports/render/pbix", {
			raw,
			params,
		});
	}
};